module.exports = __webpack_public_path__ + "static/6-61b0b699a0edd80d152603f8be4b2668.jpg";